module.exports = __webpack_public_path__ + "static/media/194.8516e1c4.jpg";